/* La Serre ODEN — ouverture du widget Joy depuis les CTA de la page.

   Le SDK de Joy expose openWidget()/closeWidget() mais AUCUNE navigation
   par vue : viser un onglet précis impose de recharger la page avec
   ?open_joy=<deeplink>, que Joy ne lit qu'au chargement.

   On privilégie donc la cohérence : tous les CTA de la page ouvrent le
   drawer à l'identique, sans rechargement, comme le lanceur flottant.
   Seule exception, le profil sur les LP personnalisées : cette vue n'est
   atteignable que par l'URL, et c'est le seul CTA de ce type sur sa page.

   On nettoie aussi ?open_joy une fois Joy initialisée : sans ça, un
   paramètre laissé dans l'URL rouvrait le drawer sur la vue précédente
   (le parrainage, typiquement) à chaque ouverture suivante. */
(function () {
  if (window.__serreJoyDeeplink) return;
  window.__serreJoyDeeplink = true;

  var PAR_URL = ['joy-profile'];

  function recharger(cible) {
    var params = new URLSearchParams(window.location.search);
    params.set('open_joy', cible);
    window.location.assign(window.location.pathname + '?' + params.toString());
  }

  function ouvrirViaSdk() {
    try {
      var joy = window.joyInstance;
      if (joy && typeof joy.openWidget === 'function') { joy.openWidget(); return true; }
    } catch (err) { /* SDK absent ou pas encore prêt */ }
    return false;
  }

  function nettoyerUrl() {
    var params = new URLSearchParams(window.location.search);
    if (!params.has('open_joy')) return;
    params.delete('open_joy');
    var qs = params.toString();
    window.history.replaceState({}, '', window.location.pathname + (qs ? '?' + qs : ''));
  }

  window.addEventListener('joy:ready', nettoyerUrl);
  window.addEventListener('load', function () { setTimeout(nettoyerUrl, 1500); });

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    var lien = e.target.closest && e.target.closest('a[href*="open_joy="]');
    if (!lien) return;

    var cible = new URLSearchParams(lien.getAttribute('href').replace(/^\?/, '')).get('open_joy');
    if (!cible) return;

    e.preventDefault();

    if (PAR_URL.indexOf(cible) === -1 && ouvrirViaSdk()) return;
    recharger(cible);
  });
})();
